import RadioField from 'js/components/RadioField/RadioField'

import Column from './components/Column'
import Wrapper from './components/Wrapper'

type Props = {
    title?: string
    value: number
    checked?: boolean
    features: Record<string, string>
    setOption: (value: number) => void
}

const Option = ({ title, value, checked, features, setOption }: Props) => {
    const handleChange = () => {
        setOption(value)
    }

    return (
        <Column mobileLandscapeUp={1 / 3}>
            <Wrapper checked={checked as any} {...({} as any)}>
                <div className="OptionCard">
                    <div>
                        <label className="OptionTitle" htmlFor={String(value)}>
                            {title}
                        </label>
                        <ul className="OptionList">
                            {Object.entries(features).map(([key, feature]) => (
                                <li key={key} className="OptionListItem">
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <RadioField
                    name="groupType"
                    id={String(value)}
                    checked={checked}
                    style={
                        {
                            position: 'static',
                            alignItems: 'center',
                            justifyContent: 'center',
                        } as any
                    }
                    onChange={handleChange as any}
                    {...({} as any)}
                />
            </Wrapper>
        </Column>
    )
}

export default Option
